import api, { type ApiResponse } from "./api";

export type PublicAppDetail = {
  id: string;
  name: string;
  slug: string;
  problem_solved: string | null;
  short_description: string | null;
  developer_website: string | null;
  apps_for_sale: boolean;
  published_at: string | null;
  category_name: string | null;
  publisher_name: string | null;
  version_number: string | null;
  file_size_bytes: number | null;
  downloads: number;
  reviews: number;
  average_rating: number | null;
  icon_url: string | null;
};

export type PublicAppScreenshot = {
  url: string | null;
  file_name: string;
  display_order: number;
};

export async function fetchPublicAppBySlug(slug: string): Promise<{
  app: PublicAppDetail;
  screenshots: PublicAppScreenshot[];
}> {
  const response = await api.get<
    ApiResponse<{ app: PublicAppDetail; screenshots: PublicAppScreenshot[] }>
  >(`/marketplace/apps/${encodeURIComponent(slug)}`);

  return response.data.data;
}

export type AppDownloadResponse = {
  downloadUrl: string;
  fileName: string | null;
};

export async function requestAppDownload(
  applicationId: string,
): Promise<AppDownloadResponse> {
  const response = await api.post<ApiResponse<AppDownloadResponse>>(
    `/marketplace/apps/${encodeURIComponent(applicationId)}/download`,
  );

  return response.data.data;
}
